import { useGlobal } from 'reactn';
import { Query } from 'react-apollo';
import { get } from 'lodash';
import TimesheetApprovalList from './TimesheetApprovalList';
import Card from '../../common/components/Card';
import { GET_TIMESHEETS_FOR_APPROVAL } from '../queries';

const TimesheetApprovalListContainer = ({ projectId }) => {
  const [user] = useGlobal('user');

  return (
    <Query query={GET_TIMESHEETS_FOR_APPROVAL} variables={{ projectId }}>
      {({ loading, error, data }) => {
        if (error) throw new Error(error);
        return (
          <Card border padded={false} withShadow floating title="Pending Timesheet Approvals">
            <TimesheetApprovalList
              user={user}
              timesheets={get(data, 'projectManagement.timesheets')}
              loading={loading}
              projectId={projectId}
            />
          </Card>
        );
      }}
    </Query>
  );
};

export default TimesheetApprovalListContainer;
